import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';
import { inputClassName } from '../../utils/assetHelpers';

const MultiTagInput = ({
    id,
    label,
    values = [],
    onChange,
    options = [],
    placeholder = 'Type and press Enter to add',
}) => {
    const [inputValue, setInputValue] = useState('');

    const addValue = (raw) => {
        const next = String(raw || '').trim();
        if (!next) return;
        if (values.includes(next)) return;
        onChange([...values, next]);
        setInputValue('');
    };

    const removeValue = (value) => {
        onChange(values.filter((item) => item !== value));
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            addValue(inputValue);
        }
    };

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
            <div className="flex flex-wrap gap-2 mb-2">
                {values.map((value) => (
                    <span
                        key={value}
                        className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-blue-100 text-blue-800 text-sm"
                    >
                        {value}
                        <button
                            type="button"
                            onClick={() => removeValue(value)}
                            className="text-blue-700 hover:text-blue-900"
                            aria-label={`Remove ${value}`}
                        >
                            <FiX className="w-3 h-3" />
                        </button>
                    </span>
                ))}
            </div>
            <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={() => addValue(inputValue)}
                className={inputClassName}
                placeholder={placeholder}
                list={options.length > 0 ? id : undefined}
            />
            {options.length > 0 && (
                <datalist id={id}>
                    {options.map((option) => (
                        <option key={option} value={option} />
                    ))}
                </datalist>
            )}
            <p className="text-xs text-gray-500 mt-1">Pick from suggestions or type a new value, then press Enter.</p>
        </div>
    );
};

export default MultiTagInput;
